<template>
    <v-textarea
        v-bind="$props"
        v-on="$listeners"
    >
    </v-textarea>
</template>

<script>
    export default {
        name: "TextArea",
        props: {
            'value': {type: [String, Number]},

            'label': String,
            'prepend-icon': String,
            'append-icon': String,
            'rules': Array,
            'rows': {
                type: [Number, String],
                default: 5
            },
            'no-resize': {type: Boolean, default: true},
        },
    }
</script>

<style scoped>

</style>
